import React from "react";
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBStep,
    MDBStepper,
    MDBModal,
    MDBModalHeader,
    MDBModalBody,
} from "mdbreact";

import "../components/styles/NavBar.css";
import "../components/styles/InputNum.css";
import FooterPage from "../components/FooterPage";
import url from "../components/config/Config";

import { withRouter } from "react-router-dom";
import { formatHumansBs } from "../helpers/formatHuman";
import CartItemTable from "../components/Steps/CartItemTable";
import ResumentCompra from "../components/Steps/ResumenCompra";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
const containerStyle = {
    width: "650px",
    height: "400px",
};

class Carrito extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [], // Carrito
            currentStep: 1,
            pasosSiguiente: {
                paso1: true,
                paso2: false,
                paso3: false,
                paso4: false,
            },
            checkboxInput: false,
            validarIdentificacion: false,
            total: 0,
            alerta: false,
            mensaje: "",
            login: false,
            // Fromulario paso 2,
            correoFact: "",
            nombreFact: "",
            apellidosFact: "",
            cinitFact: "",
            telefonoFact: "",
            razonFact: "",
            // Formulario paso 3
            dirreccionPaso3: "",
            modalAlertaErrorInputs: false,
            mensajeAlertaErrorInputs: "",
            tituloMensajeAlerta: "",

            llave: "",
            idcliente: 0,
            formapago: "ContraEntrega",
            center: {
                lat: -17.7662398,
                lng: -63.1601249,
            },
            empresa: undefined,
        };
        if (localStorage.getItem("CarritoJucumari")) {
            let ca = JSON.parse(localStorage.getItem("CarritoJucumari"));
            this.state.data = ca;
        }
        if (
            localStorage.getItem("LoginJucumari") &&
            JSON.parse(localStorage.getItem("LoginJucumari")).length > 0
        ) {
            const datosLocal =
                JSON.parse(localStorage.getItem("LoginJucumari"))[0] ?? null;
            this.state.correoFact = datosLocal.correo;
            this.state.llave = datosLocal.llave;
            this.state.idcliente = datosLocal.idcliente;
            this.state.dirreccionPaso3 = datosLocal.direccion;
            this.state.telefonoFact = datosLocal.telefono;
        }
        this.CalcularTotal();
        this.getEmpresa();
    }
    componentDidMount() {
        this.Incrementar = this.Incrementar.bind(this);
        this.Decrementar = this.Decrementar.bind(this);
        this.EliminarItem = this.EliminarItem.bind(this);
        this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
        this.handleStepClick = this.handleStepClick.bind(this);
        this.formularioValidoPaso3 = this.formularioValidoPaso3.bind(this);
    }

    CalcularTotal() {
        let t = this.state.data;
        let tot = 0;
        for (var i = 0; i < t.length; i++) {
            tot = tot + t[i].cantidad * t[i].precio;
        }
        this.state.total = tot;
    }

    EliminarItem(idproducto) {
        let car = JSON.parse(localStorage.getItem("CarritoJucumari"));
        for (var i = 0; i < car.length; i++) {
            if (car[i].idprod == idproducto) {
                car.splice(i, 1);
            }
        }
        localStorage.setItem("CarritoJucumari", JSON.stringify(car));
        this.setState({ data: car });
        window.dispatchEvent(new Event("storage"));
        this.CalcularTotal();
    }

    Decrementar(cant, idprod) {
        if (cant > 1) {
            let dec = JSON.parse(localStorage.getItem("CarritoJucumari"));
            for (var i = 0; i < dec.length; i++) {
                if (dec[i].idprod == idprod) {
                    dec[i].cantidad = cant;
                }
            }
            localStorage.setItem("CarritoJucumari", JSON.stringify(dec));
            window.dispatchEvent(new Event("storage"));
            this.setState({ data: dec });
            this.CalcularTotal();
        } else this.EliminarItem(idprod);
    }
    Incrementar(cant, idprod) {
        let inc = JSON.parse(localStorage.getItem("CarritoJucumari"));
        for (var i = 0; i < inc.length; i++) {
            if (inc[i].idprod == idprod) {
                inc[i].cantidad = cant;
            }
        }
        localStorage.setItem("CarritoJucumari", JSON.stringify(inc));
        window.dispatchEvent(new Event("storage"));
        this.setState({ data: inc });
        this.CalcularTotal();
    }
    RealizarPedido = () => {
        const { history } = this.props;
        if (this.state.data.length > 0) {
            if (localStorage.getItem("LoginJucumari")) {
                if (localStorage.getItem("CarritoJucumari")) {
                    history.push(
                        "/RealizarPedido" +
                            "?e=".concat(localStorage.getItem("empresa"))
                    );
                    //window.location.assign("/RealizarPedido" + '?e='.concat(localStorage.getItem('empresa')));
                } else {
                    history.push(
                        "/Login" + "?e=".concat(localStorage.getItem("empresa"))
                    );
                    //window.location.assign("/Login" + '?e='.concat(localStorage.getItem('empresa')));
                }
            } else {
                this.setState({ mensaje: "Debe Iniciar Sesion" });
                this.setState({ alerta: !this.state.alerta });
                this.setState({ login: true });
            }
        } else {
            this.setState({ mensaje: "Carrito Vacio" });
            this.setState({ alerta: !this.state.alerta });
        }
    };

    handleStepClick = (step) => {
        if (step === 1) {
            this.setState({ currentStep: step });
            this.setState((prevState) => ({
                pasosSiguiente: {
                    ...prevState.pasosSiguiente,
                    paso1: true,
                    paso2: false,
                    paso3: false,
                    paso4: false,
                },
            }));
        }
        if (step === 2) {
            if (!this.state.checkboxInput) return;
            if (!this.state.pasosSiguiente.paso1) return;
            this.setState({ currentStep: step });
            this.setState((prevState) => ({
                pasosSiguiente: {
                    ...prevState.pasosSiguiente,
                    paso2: true,
                    paso3: false,
                    paso4: false,
                },
            }));
        }
        if (step === 3) {
            if (
                !this.state.pasosSiguiente.paso1 ||
                !this.state.pasosSiguiente.paso2 ||
                !this.state.validarIdentificacion
            )
                return;
            this.setState({ currentStep: step });
            this.setState((prevState) => ({
                pasosSiguiente: {
                    ...prevState.pasosSiguiente,
                    paso3: true,
                    paso4: false,
                },
            }));
            console.log("entra");
            // this.handleSubmitFormularioPaso();
        }
        if (step === 4) {
            if (
                !this.state.pasosSiguiente.paso1 ||
                !this.state.pasosSiguiente.paso2 ||
                !this.state.pasosSiguiente.paso3 ||
                this.state.dirreccionPaso3.trim() === ""
            )
                return;
            this.setState({ currentStep: step });
            this.setState((prevState) => ({
                pasosSiguiente: {
                    ...prevState.pasosSiguiente,
                    paso4: true,
                },
            }));
        }
    };

    handleChangeCheckbox(e) {
        this.setState((prevState) => ({
            checkboxInput: !prevState.checkboxInput,
        }));
    }
    setStateNombrePaso2(e) {
        this.setState({ nombreFact: e.target.value });
    }
    setStateCorreoPaso2(e) {
        this.setState({ correoFact: e.target.value });
    }
    setStateCiNitPaso2(e) {
        this.setState({ cinitFact: e.target.value });
    }
    setStateApellidosPaso2(e) {
        this.setState({ apellidosFact: e.target.value });
    }
    setStateTelefonoPaso2(e) {
        this.setState({ telefonoFact: e.target.value });
    }
    setStateRazonPaso2(e) {
        this.setState({ razonFact: e.target.value });
    }
    handleSubmitFormularioPaso() {
        this.formularioValidoPaso3(false);
        const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
        if (
            this.state.correoFact.trim() === "" ||
            !emailRegex.test(this.state.correoFact)
        ) {
            this.setState({ modalAlertaErrorInputs: true });
            this.setState({ tituloMensajeAlerta: "Error campos obligatorios" });
            this.setState({
                mensajeAlertaErrorInputs: "Correo electronico es obligatorio",
            });

            setTimeout(() => {
                this.setState({ modalAlertaErrorInputs: false });
                this.setState({ mensajeAlertaErrorInputs: "" });
                this.setState({ tituloMensajeAlerta: "" });
            }, 2000);
            return;
        }
        if (this.state.nombreFact.trim() === "") {
            this.setState({ modalAlertaErrorInputs: true });
            this.setState({
                mensajeAlertaErrorInputs: "Nombre es obligatorio",
            });
            this.setState({ tituloMensajeAlerta: "Error campos obligatorios" });
            setTimeout(() => {
                this.setState({ modalAlertaErrorInputs: false });
                this.setState({ mensajeAlertaErrorInputs: "" });
                this.setState({ tituloMensajeAlerta: "" });
            }, 2000);
            return;
        }
        if (this.state.apellidosFact.trim() === "") {
            this.setState({ modalAlertaErrorInputs: true });
            this.setState({
                mensajeAlertaErrorInputs: "Apellido es obligatorio",
            });
            this.setState({ tituloMensajeAlerta: "Error campos obligatorios" });
            setTimeout(() => {
                this.setState({ modalAlertaErrorInputs: false });
                this.setState({ mensajeAlertaErrorInputs: "" });
                this.setState({ tituloMensajeAlerta: "" });
            }, 2000);
            return;
        }
        if (this.state.cinitFact.trim() === "") {
            this.setState({ modalAlertaErrorInputs: true });
            this.setState({
                mensajeAlertaErrorInputs: "Carnet o Nit es obligatorio",
            });
            this.setState({ tituloMensajeAlerta: "Error campos obligatorios" });
            setTimeout(() => {
                this.setState({ modalAlertaErrorInputs: false });
                this.setState({ mensajeAlertaErrorInputs: "" });
                this.setState({ tituloMensajeAlerta: "" });
            }, 2000);
            return;
        }
        if (this.state.telefonoFact.trim() === "") {
            this.setState({ modalAlertaErrorInputs: true });
            this.setState({
                mensajeAlertaErrorInputs: "Teléfono es obligatorio",
            });
            this.setState({ tituloMensajeAlerta: "Error campos obligatorios" });
            setTimeout(() => {
                this.setState({ modalAlertaErrorInputs: false });
                this.setState({ mensajeAlertaErrorInputs: "" });
                this.setState({ tituloMensajeAlerta: "" });
            }, 2000);
            return;
        }
        if (this.state.razonFact.trim() === "") {
            this.setState({ modalAlertaErrorInputs: true });
            this.setState({
                mensajeAlertaErrorInputs: "Razon social",
            });
            this.setState({ tituloMensajeAlerta: "Error campos obligatorios" });
            setTimeout(() => {
                this.setState({ modalAlertaErrorInputs: false });
                this.setState({ mensajeAlertaErrorInputs: "" });
                this.setState({ tituloMensajeAlerta: "" });
            }, 2000);
            return;
        }

        this.formularioValidoPaso3(true);
    }

    formularioValidoPaso3(siguiente) {
        this.setState({ validarIdentificacion: siguiente }, () => {
            this.handleStepClick(3);
        });
    }

    setStateDirreccionPaso3(e) {
        this.setState({ dirreccionPaso3: e.target.value });
    }
    handleSubmitFormularioPaso3() {
        if (this.state.dirreccionPaso3.trim() === "") {
            this.setState({ modalAlertaErrorInputs: true });
            this.setState({
                mensajeAlertaErrorInputs: "Dirreción es obligatoria",
                tituloMensajeAlerta: "Error campos obligatorios",
            });
            setTimeout(() => {
                this.setState({ modalAlertaErrorInputs: false });
                this.setState({ tituloMensajeAlerta: "" });
                this.setState({ mensajeAlertaErrorInputs: "" });
            }, 2000);
            return;
        }
        this.handleStepClick(4);
    }
    Enviar = () => {
        let venta = {
            llave: this.state.llave,
            accion: "agregarVentaOnline",
            carrito: this.state.data.map((carState) => {
                return {
                    idproducto: parseInt(carState.idprod),
                    cantidad: carState.cantidad,
                    producto: {
                        imagen: "",
                    },
                };
            }),
            identificador: this.state.formapago,
            costoEnvio: 15,
            cliente: {
                ci: "",
                correo: this.state.correoFact,
                direccion: this.state.dirreccionPaso3,
                estado: "1",
                idcliente: this.state.idcliente,
                imagen: "",
                latitud: "",
                longitud: "",
                nit: this.state.cinitFact,
                nombre: this.state.nombreFact,
                obsv: "",
                pass: "",
                recuperarpass: "",
                sexo: "",
                telefono: this.state.telefonoFact,
            },
            ruta: {
                longitud: this.state.center.lat,
                latitud: this.state.center.lng,
            },
            idlistaprecio: this.state.empresa.idlistaprecios,
            idalmacen: this.state.empresa.idalmacen,
        };
        fetch(url.service + "ventaNP", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(venta),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                let v = responseJson;
                if (v.payment_url == undefined) {
                    alert(v.venta);
                    const { history } = this.props;
                    history.push(
                        "/Carrito" +
                            "?e=".concat(localStorage.getItem("empresa"))
                    );
                    // window.location.assign("/Carrito"+'?e='.concat(localStorage.getItem('empresa')))
                } else {
                    localStorage.removeItem("CarritoJucumari");
                    window.dispatchEvent(new Event("storage"));

                    this.setState({ modalAlertaErrorInputs: true });
                    this.setState({ tituloMensajeAlerta: "Exito" });
                    this.setState({
                        mensajeAlertaErrorInputs:
                            "Pedido realizado correctamente",
                    });
                    this.setState({ modalAlerta: !this.state.modalAlerta });

                    window.location.assign(
                        "/" + "?e=".concat(localStorage.getItem("empresa"))
                    );
                }
            });
    };
    getEmpresa() {
        let datos = {
            accion: "getEmpresa",
            llave: url.llavedefault,
        };
        fetch(url.service + "empresa", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(datos),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.setState({ empresa: responseJson[0] });
            });
    }
    onDragEnd = (e) => {
        this.state.center.lat = e.latLng.lat();
        this.state.center.lng = e.latLng.lng();
    };
    siguienteButton = () => {
        if (this.state.currentStep + 1 === 2) {
            this.handleStepClick(2);
        }
        if (this.state.currentStep + 1 === 3) {
            this.handleSubmitFormularioPaso();
        }
        if (this.state.currentStep + 1 === 4) {
            this.handleSubmitFormularioPaso3();
        }
        if (this.state.currentStep === 4) {
            this.Enviar();
        }
    };

    render() {
        return (
            <>
                <div className="mt-2 lg:my-8"></div>
                <MDBModal
                    isOpen={this.state.modalAlertaErrorInputs}
                    // isOpen={true}
                    toggle={() => {
                        // setModalSidebarCarrito(!modalSidebarCarrito);
                    }}
                    position="top-top"
                    wrapClassName={`w-100 position-fixed`}
                    backdrop={false}
                >
                    <MDBModalHeader tag="div" titleClass="heading lead">
                        <p className="font-bold text-center">
                            {this.state.tituloMensajeAlerta}
                        </p>
                    </MDBModalHeader>
                    <MDBModalBody className="text-center">
                        <p>{this.state.mensajeAlertaErrorInputs}</p>
                    </MDBModalBody>
                </MDBModal>
                <div className="lg:max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 lg:grid-cols-4 justify-between">
                        <div className="col-span-1 flex items-center justify-between p-2 lg:p-0 w-full lg:bg-gray-50 bg-tertiary-personalize">
                            <a
                                href={
                                    "/" +
                                    "?e=".concat(
                                        localStorage.getItem("empresa")
                                    )
                                }
                                className="flex items-center gap-1 text-gray-50 lg:text-black text-sm  lg:text-base font-semibold"
                            >
                                <i className="fas fa-arrow-left "></i>
                                Seguir comprando
                            </a>
                            <div className="block lg:hidden">
                                <button
                                    style={{
                                        padding: "0",
                                        margin: "0",
                                        height: "auto",
                                    }}
                                    className={` w-full py-2  text-white text-center font-bold rounded-md hover:no-underline text-sm bg-tertiary-personalize`}
                                    onClick={() => this.siguienteButton()}
                                >
                                    { this.state.currentStep === 4 ? "Finalizar" : "Siguiente" }
                                </button>
                            </div>
                        </div>
                        <div className="col-span-3 mb-3 lg:mb-0 px-2">
                            <ol className="mt-3 lg:mt-0 flex items-center w-full text-xs text-gray-900 font-medium sm:text-base">
                                <li
                                    className={`flex w-full justify-start lg:justify-end relative text-black  after:content-['']  after:w-full after:justify-center after:h-1  ${
                                        this.state.pasosSiguiente.paso2
                                            ? "after:bg-tertiary-personalize"
                                            : "after:bg-gray-200"
                                    } after:inline-block after:absolute lg:after:top-5 after:top-3 after:left-6 lg:after:left-48 after:w-full `}
                                >
                                    <div className="block whitespace-nowrap z-10 text-center">
                                        <span
                                            onClick={() =>
                                                this.handleStepClick(1)
                                            }
                                            className="w-9 h-9 bg-tertiary-personalize border-2 border-transparent rounded-full flex justify-center items-center mx-auto mb-1 text-sm text-white lg:w-12 lg:h-12"
                                        >
                                            <i className="fa fa-shopping-cart text-base lg:text-lg"></i>
                                        </span>{" "}
                                        <span className="text-xs lg:text-sm">
                                            Carrito
                                        </span>
                                    </div>
                                </li>
                                <li
                                    className={`flex w-full justify-start lg:justify-end relative text-gray-900  after:content-['']  after:w-full after:h-1 after:inline-block after:absolute lg:after:top-5 after:top-3 after:left-12 lg:after:left-48 ${
                                        this.state.pasosSiguiente.paso3
                                            ? "after:bg-tertiary-personalize "
                                            : "after:bg-gray-200 "
                                    }`}
                                >
                                    <div className="block whitespace-nowrap z-10 text-center">
                                        <span
                                            onClick={() =>
                                                this.handleStepClick(2)
                                            }
                                            className={`w-9 h-9 ${
                                                this.state.pasosSiguiente.paso2
                                                    ? "bg-tertiary-personalize text-white"
                                                    : "bg-gray-200 text-black"
                                            } border-1 rounded-full flex justify-center items-center mx-auto mb-1 text-sm  lg:w-12 lg:h-12`}
                                        >
                                            <i className="fa fa-user text-base lg:text-xl"></i>
                                        </span>{" "}
                                        <span className="text-xs lg:text-sm">
                                            Identificación
                                        </span>
                                    </div>
                                </li>
                                <li
                                    className={`flex w-full justify-start lg:justify-end relative text-gray-900  after:content-['']  after:w-full after:h-1   after:inline-block after:absolute lg:after:top-5  after:top-3 after:left-14 lg:after:left-48  ${
                                        this.state.pasosSiguiente.paso4
                                            ? "after:bg-tertiary-personalize"
                                            : "after:bg-gray-200"
                                    }`}
                                >
                                    <div className="block whitespace-nowrap z-10 text-center">
                                        <span
                                            onClick={() =>
                                                this.handleStepClick(3)
                                            }
                                            className={`w-9 h-9 bg-gray-200 rounded-full flex justify-center items-center mx-auto mb-1 text-sm lg:w-12 lg:h-12 ${
                                                this.state.pasosSiguiente.paso3
                                                    ? "bg-tertiary-personalize text-white"
                                                    : "bg-gray-200 text-black"
                                            }`}
                                        >
                                            <i className="fa fa-home text-base lg:text-xl"></i>
                                        </span>{" "}
                                        <span className="text-xs lg:text-sm">
                                            Método entrega
                                        </span>
                                    </div>
                                </li>
                                <li
                                    className={`flex justify-end lg:justify-end w-full relative text-black`}
                                >
                                    <div className="block whitespace-nowrap z-10 text-center">
                                        <span
                                            className={`w-9 h-9 bg-gray-200 rounded-full flex justify-center items-center lg:mx-auto ml-6 lg:ml-auto  mb-1 text-sm text-black lg:w-12 lg:h-12 ${
                                                this.state.pasosSiguiente.paso4
                                                    ? "bg-tertiary-personalize text-white"
                                                    : "bg-gray-200 text-black"
                                            }`}
                                        >
                                            <i className="fa fa-user text-base lg:text-lg"></i>
                                        </span>{" "}
                                        <span className="text-xs lg:text-sm">
                                            Método pago
                                        </span>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div className="max-w-6xl mx-auto mt-2">
                        {this.state.currentStep === 1 && (
                            <div className="grid grid-cols-1 lg:grid-cols-4 gap-2">
                                {this.state.data.length ? (
                                    <>
                                        <div className="col-span-3">
                                            <div className="px-2 lg:p-4 bg-white">
                                                <div className="relative overflow-x-auto">
                                                    <table className="w-full  text-left">
                                                        <thead className="text-lg  bg-white">
                                                            <tr className="">
                                                                <th
                                                                    scope="col"
                                                                    className="px-2 lg:px-6 py-1 font-bold border-b border-gray-200"
                                                                >
                                                                    Producto
                                                                </th>
                                                                <th
                                                                    scope="col"
                                                                    className="px-6 py-1 font-bold border-b border-gray-200"
                                                                >
                                                                    Cantidad
                                                                </th>
                                                                <th
                                                                    scope="col"
                                                                    className="px-6 py-1 font-bold border-b border-gray-200"
                                                                >
                                                                    Precio
                                                                </th>
                                                                <th
                                                                    scope="col"
                                                                    className="px-6 py-1 font-bold border-b border-gray-200"
                                                                >
                                                                    Acciones
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.data.map(
                                                                (
                                                                    item,
                                                                    index
                                                                ) => (
                                                                    <CartItemTable
                                                                        key={
                                                                            index
                                                                        }
                                                                        item={
                                                                            item
                                                                        }
                                                                        incrementar={
                                                                            this
                                                                                .Incrementar
                                                                        }
                                                                        decrementar={
                                                                            this
                                                                                .Decrementar
                                                                        }
                                                                        eliminarItem={
                                                                            this
                                                                                .EliminarItem
                                                                        }
                                                                        esUltimo={
                                                                            index ===
                                                                            this
                                                                                .state
                                                                                .data
                                                                                .length -
                                                                                1
                                                                        }
                                                                    />
                                                                )
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-span-1">
                                            <div className="px-3 bg-white space-y-4">
                                                <div>
                                                    <div>
                                                        <p className="flex items-center justify-between">
                                                            <span className="text-md text-gray-500">
                                                                SubTotal:
                                                            </span>
                                                            <span className="">
                                                                {formatHumansBs(
                                                                    this.state
                                                                        .total
                                                                )}
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <hr />
                                                    <p className="flex items-center justify-between">
                                                        <span className="text-md font-bold">
                                                            Total:
                                                        </span>
                                                        <span className="text-tertiary-personalize text-lg font-bold">
                                                            {formatHumansBs(
                                                                this.state.total
                                                            )}
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="flex items-center gap-4">
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            checked={
                                                                this.state
                                                                    .checkboxInput
                                                            }
                                                            onChange={(e) =>
                                                                this.handleChangeCheckbox(
                                                                    e
                                                                )
                                                            }
                                                            className="w-4 h-4 accent-blue-600 rounded-lg bg-white border-gray-300 focus:ring-blue-500 focus:ring-2"
                                                            style={{
                                                                opacity:
                                                                    "unset",
                                                                position:
                                                                    "relative",
                                                                zIndex: 10,
                                                                pointerEvents:
                                                                    "auto",
                                                            }}
                                                        />
                                                    </div>
                                                    <p className="truncate lg:overflow-visible lg:whitespace-normal lg:text-clip">
                                                        He leído y acepto los{" "}
                                                        <span className="text-tertiary-personalize">
                                                            Términos y
                                                            condiciones
                                                        </span>{" "}
                                                        de compra en empresa.
                                                        Acepto igualmente la
                                                        politica de privacidad y
                                                        seguridad.
                                                    </p>
                                                </div>
                                                <button
                                                    style={{
                                                        height: "auto",
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                    className={`hidden lg:block w-full mt-2 p-2 text-white text-center font-bold rounded-md hover:no-underline ${
                                                        this.state.checkboxInput
                                                            ? "bg-tertiary-personalize"
                                                            : "bg-gray-400 cursor-not-allowed"
                                                    }`}
                                                    disabled={
                                                        !this.state
                                                            .checkboxInput
                                                    }
                                                    onClick={() =>
                                                        this.handleStepClick(2)
                                                    }
                                                >
                                                    Siguiente Paso
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <MDBCol md="12">
                                        <p className="text-3xl font-bold">
                                            Su carrito está vacío
                                        </p>
                                        <p className="mb-4">
                                            Para seguir comprando, agregue un
                                            producto.
                                        </p>
                                        <a
                                            href={
                                                "/" +
                                                "?e=".concat(
                                                    localStorage.getItem(
                                                        "empresa"
                                                    )
                                                )
                                            }
                                            className="text-white my-2 p-3 text-center text-lg font-bold rounded-md hover:no-underline"
                                            style={{
                                                backgroundColor:
                                                    url.colorprimario,
                                            }}
                                        >
                                            Elegir productos
                                        </a>
                                    </MDBCol>
                                )}
                            </div>
                        )}
                        {this.state.currentStep === 2 && (
                            <div className="grid grid-cols-1 lg:grid-cols-4 gap-2 px-2">
                                <div className="col-span-3">
                                    <div className="p-1 lg:p-4">
                                        <h1 className="font-bold text-2xl text-center lg:text-start">
                                            Identificación
                                        </h1>
                                        <div>
                                            <div className="my-2 space-y-2">
                                                <div>
                                                    <label
                                                        htmlFor="email"
                                                        className="text-gray-600 block"
                                                    >
                                                        Correo
                                                    </label>
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        value={
                                                            this.state
                                                                .correoFact
                                                        }
                                                        onChange={(e) =>
                                                            this.setStateCorreoPaso2(
                                                                e
                                                            )
                                                        }
                                                        id="email"
                                                        className="p-2 focus:ring-1 focus:ring-gray-300 border rounded w-full border-gray-800 focus:outline-none focus:shadow-md"
                                                        placeholder="Ingrese su Correo"
                                                    />
                                                </div>
                                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                                                    <div>
                                                        <label
                                                            htmlFor="nombres"
                                                            className="text-gray-600 block"
                                                        >
                                                            Nombres
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="nombres"
                                                            value={
                                                                this.state
                                                                    .nombreFact
                                                            }
                                                            onChange={(e) =>
                                                                this.setStateNombrePaso2(
                                                                    e
                                                                )
                                                            }
                                                            id="nombres"
                                                            className="p-2 focus:ring-1 focus:ring-gray-300 border rounded w-full border-gray-800 focus:outline-none focus:shadow-md"
                                                            placeholder="Ingrese su Nombre"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label
                                                            htmlFor="apellidos"
                                                            className="text-gray-600 block"
                                                        >
                                                            Apellidos
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="apellidos"
                                                            value={
                                                                this.state
                                                                    .apellidosFact
                                                            }
                                                            onChange={(e) =>
                                                                this.setStateApellidosPaso2(
                                                                    e
                                                                )
                                                            }
                                                            id="apellidos"
                                                            className="p-2 focus:ring-1 focus:ring-gray-300 border rounded w-full border-gray-800 focus:outline-none focus:shadow-md"
                                                            placeholder="Ingrese sus apellidos"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                                                    <div>
                                                        <label
                                                            htmlFor="cinit"
                                                            className="text-gray-600 block"
                                                        >
                                                            Cédula de Identidad
                                                            / Nit
                                                        </label>
                                                        <input
                                                            type="number"
                                                            name="cinit"
                                                            id="cinit"
                                                            value={
                                                                this.state
                                                                    .cinitFact
                                                            }
                                                            onChange={(e) =>
                                                                this.setStateCiNitPaso2(
                                                                    e
                                                                )
                                                            }
                                                            className="p-2 focus:ring-1 focus:ring-gray-300 border rounded w-full border-gray-800 focus:outline-none focus:shadow-md"
                                                            placeholder="Ingrese su cédula de identidad / nit"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label
                                                            htmlFor="telefono"
                                                            className="text-gray-600 block"
                                                        >
                                                            Télefono / Móvil
                                                        </label>
                                                        <input
                                                            type="number"
                                                            value={
                                                                this.state
                                                                    .telefonoFact
                                                            }
                                                            onChange={(e) =>
                                                                this.setStateTelefonoPaso2(
                                                                    e
                                                                )
                                                            }
                                                            name="telefono"
                                                            id="telefono"
                                                            className="p-2 focus:ring-1 focus:ring-gray-300 border rounded w-full border-gray-800 focus:outline-none focus:shadow-md"
                                                            placeholder="Ingrese sus télefono / móvil"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label
                                                        htmlFor="razon-social"
                                                        className="text-gray-600 block"
                                                    >
                                                        Razón social
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="razon-social"
                                                        id="razon-social"
                                                        value={
                                                            this.state.razonFact
                                                        }
                                                        onChange={(e) =>
                                                            this.setStateRazonPaso2(
                                                                e
                                                            )
                                                        }
                                                        className="p-2 focus:ring-1 focus:ring-gray-300 border rounded w-full border-gray-800 focus:outline-none focus:shadow-md"
                                                        placeholder="Ingrese su Razon social para la facturación"
                                                    />
                                                </div>
                                                <div className="flex justify-center w-full">
                                                    <button
                                                        style={{
                                                            padding: "0",
                                                            margin: "0",
                                                            height: "auto",
                                                        }}
                                                        type="button"
                                                        className={`hidden lg:block mt-2 text-white text-center font-bold rounded-md hover:no-underline px-3 py-2 bg-tertiary-personalize`}
                                                        onClick={() =>
                                                            this.handleSubmitFormularioPaso()
                                                        }
                                                    >
                                                        Ir a método de entrega
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-span-1">
                                    <ResumentCompra />

                                </div>
                            </div>
                        )}
                        {this.state.currentStep === 3 && (
                            <div className="grid grid-cols-1 lg:grid-cols-4 gap-2 px-2">
                                <div className="col-span-3">
                                    <div className="p-1 lg:p-4">
                                        <h2 className="font-bold mb-2 text-center lg:text-start text-2xl">
                                            Método de entrega
                                        </h2>
                                        <div className="my-2 space-y-2">
                                            <div>
                                                <label
                                                    htmlFor="dirrecion"
                                                    className="text-gray-600 block"
                                                >
                                                    Dirreción
                                                </label>
                                            </div>
                                            <div className="relative">
                                                <input
                                                    type="text"
                                                    name="dirrecion"
                                                    value={
                                                        this.state
                                                            .dirreccionPaso3
                                                    }
                                                    onChange={(e) =>
                                                        this.setStateDirreccionPaso3(
                                                            e
                                                        )
                                                    }
                                                    id="dirrecion"
                                                    className="pl-9 py-2 focus:ring-1 focus:ring-gray-300 border rounded w-full border-gray-800 focus:outline-none focus:shadow-md"
                                                    placeholder="Ingrese su dirreción"
                                                />
                                                <i className="fa fa-home absolute top-1/2 left-3 -translate-y-1/2"></i>
                                            </div>
                                            <LoadScript
                                                googleMapsApiKey={url.llavemapa}
                                            >
                                                <GoogleMap
                                                    mapContainerClassName="w-[400px] lg:w-[740px] h-[300px] sm:h-[400px] md:h-[500px]"
                                                    center={this.state.center}
                                                    zoom={15}
                                                >
                                                    <Marker
                                                        title="Mi Ubicación"
                                                        position={
                                                            this.state.center
                                                        }
                                                        draggable
                                                        onDragEnd={(e) =>
                                                            this.onDragEnd(e)
                                                        }
                                                    />
                                                </GoogleMap>
                                            </LoadScript>
                                            <div className="flex justify-center w-full">
                                                <button
                                                    style={{
                                                        padding: "0",
                                                        margin: "0",
                                                        height: "auto",
                                                    }}
                                                    type="button"
                                                    className={`hidden lg:block text-white text-center font-bold rounded-md hover:no-underline px-3 py-2 bg-tertiary-personalize`}
                                                    onClick={() =>
                                                        this.handleSubmitFormularioPaso3()
                                                    }
                                                >
                                                    Ir a método de pago
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-span-1">
                                    <ResumentCompra />

                                </div>
                            </div>
                        )}
                        {this.state.currentStep === 4 && (
                            <div className="grid grid-cols-1 lg:grid-cols-4 gap-2 px-2">
                                <div className="col-span-3">
                                    <h1 className="font-bold text-2xl text-center lg:text-start">
                                        Método de Pago
                                    </h1>
                                    <p>Pago ContraEntrega</p>
                                    <button
                                        style={{
                                            padding: "0",
                                            margin: "0",
                                            height: "auto",
                                        }}
                                        type="button"
                                        className={`hidden lg:block text-white text-center font-bold rounded-md hover:no-underline bg-tertiary-personalize px-3 py-2`}
                                        onClick={() => this.Enviar()}
                                    >
                                        Finalizar
                                    </button>
                                </div>
                                <div className="col-span-1">
                                    <ResumentCompra />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="my-12"></div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </>
        );
    }
}
export default withRouter(Carrito);
